import { type CustomLine, type ProductLine } from 'graphql/models/generated';

import { isProductLine } from './is-product-line';

/** If the line is groupable, i.e. added to a group as a child line. */
export function isGroupableLine(
  line: CustomLine | ProductLine
): line is ProductLine {
  return isProductLine(line) && line.product.isConfigurable;
}
